import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout, getNombreFromToken } from './services/auth';
import Dashboard from './pages/Dashboard';
import Campanias from './pages/Campanias';
import Contenido from './pages/Contenido';
import Configuracion from './pages/Configuracion';
import './Principal.css';

export default function Principal() {
  const [seccionActual, setSeccionActual] = useState('dashboard');
  const [nombreUsuario, setNombreUsuario] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const nombre = getNombreFromToken();
    setNombreUsuario(nombre || 'Usuario');
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const renderSeccion = () => {
    switch (seccionActual) {
      case 'dashboard': return <Dashboard />;
      case 'campanias': return <Campanias />;
      case 'contenido': return <Contenido />;
      case 'configuracion': return <Configuracion />;
      default: return <Dashboard />;
    }
  };

  const menuItems = [
    { id: 'dashboard', icon: '📊', label: 'Dashboard' },
    { id: 'campanias', icon: '🚀', label: 'Campañas' },
    { id: 'contenido', icon: '📝', label: 'Contenido' },
    { id: 'configuracion', icon: '⚙️', label: 'Configuración' },
  ];

  return (
    <div className="principal-layout">
      {/* BARRA LATERAL */}
      <aside className="principal-sidebar">
        <div className="principal-sidebar-logo">
          <img 
            src="/logo2.png" 
            alt="Sinteligen" 
            className="principal-logo-img"
          />
        </div>

        <nav className="principal-sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setSeccionActual(item.id)}
              className={`principal-sidebar-btn ${seccionActual === item.id ? 'active' : ''}`}
              title={item.label}
            >
              <span className="principal-sidebar-icon">{item.icon}</span>
            </button>
          ))}
        </nav>
      </aside>

      {/* CONTENIDO PRINCIPAL */}
      <main className="principal-main">
        <header className="principal-header">
          <div className="principal-header-left">
            <img 
              src="/sinteligen4.png" 
              alt="Sinteligen" 
              className="principal-header-logo"
            />
          </div>

          <div className="principal-header-right">
            <span className="principal-user-name">👤 {nombreUsuario}</span>
            <button className="principal-logout-btn" onClick={handleLogout}>
              Cerrar sesión
            </button>
          </div>
        </header>

        <div className="principal-content">
          {renderSeccion()}
        </div>
      </main>
    </div>
  );
}